export { default as DiarioOcorrencias } from "./DiarioOcorrencias"
export { default as TableDiarioOcorrencias } from "./TableDiarioOcorrencias"
export {
  default as DiarioOcorrenciasCreateForm
} from "./DiarioOcorrenciasCreateForm"
export {
  default as DiarioOcorrenciasEditForm
} from "./DiarioOcorrenciasEditForm"
export { default as DiarioOcorrenciasTrash } from "./DiarioOcorrenciasTrash"
export {
  default as TableDiarioOcorrenciasTrash
} from "./TableDiarioOcorrenciasTrash"



// WEBPACK FOOTER //
// ./src/views/fiscalizacao/diario-ocorrencias/index.js